import comp from "./SubmissionTableWrapper";
export default comp;
